exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common_form_search[data-v-48a73780]{padding:15px 15px 0 15px;background-color:#ffffff;border-radius:0 0 10px 10px}.child_page[data-v-48a73780]{padding:15px}[data-v-48a73780] .el-divider--horizontal{margin:0}\n", ""]);

// exports
